/**
 * @fileoverview Centralized query key builders for TanStack Query.
 * Keeps keys consistent across web and (future) native clients.
 */

/**
 * Root namespace for all keys.
 */
const ROOT = 'timegenie';

/**
 * Goals query keys.
 */
export const goalsKeys = {
  /** @param {string} userId */
  all: (userId) => [ROOT, 'goals', userId],
};

/**
 * Plans query keys.
 */
export const plansKeys = {
  /** @param {string} userId */
  all: (userId) => [ROOT, 'plans', userId],
  /** @param {string} userId @param {string} goalId */
  byGoal: (userId, goalId) => [ROOT, 'plans', userId, { goalId }],
};

/**
 * Tasks query keys.
 */
export const tasksKeys = {
  /** @param {string} userId */
  all: (userId) => [ROOT, 'tasks', userId],
  /** @param {string} userId @param {Record<string, any>} [params] */
  list: (userId, params = {}) => [ROOT, 'tasks', userId, params],
};

/**
 * Reviews query keys.
 */
export const reviewsKeys = {
  /** @param {string} userId */
  all: (userId) => [ROOT, 'reviews', userId],
};

/**
 * User profiles query keys.
 */
export const profilesKeys = {
  /** @param {string} userId */
  all: (userId) => [ROOT, 'user_profiles', userId],
};

/**
 * Chat query keys.
 */
export const chatKeys = {
  /** @param {string} userId */
  sessions: (userId) => [ROOT, 'chatSessions', userId],
  /** @param {string} sessionId */
  messages: (sessionId) => [ROOT, 'chatMessages', sessionId],
};

export default {
  ROOT,
  goalsKeys,
  plansKeys,
  tasksKeys,
  reviewsKeys,
  profilesKeys,
  chatKeys,
};
